import React, { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { useLocaleContext } from './LocaleContext';
import {
  getContentfulData,
  contentfulTranslationsConfig,
  getData
} from '../contentful';

const TranslationsContext = createContext();

export const useTranslationsContext = () => useContext(TranslationsContext);

const TranslationsContextProvider = ({ children }) => {
  const locale = useLocaleContext();
  const [translations, setTranslations] = useState(null);

  useEffect(() => {
    getContentfulData({ ...contentfulTranslationsConfig, locale }, false).then(
      res => {
        const { translations: localeTranslations } = getData(res);
        setTranslations(localeTranslations);
      }
    );
  }, [locale]);
  return (
    <TranslationsContext.Provider value={translations}>
      {translations && <>{children}</>}
    </TranslationsContext.Provider>
  );
};

TranslationsContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default TranslationsContextProvider;
